import axios from './axios'
import {
  CreateSalaryItemDto,
  InstructorSalaryOverviewItemDto,
  InstructorSalaryResponseDto,
  SalaryItemDto,
  UpdateSalaryItemDto,
} from './types'

const BASE = '/instructor-salary'

export const getInstructorSalary = (instructorId: string, month: string) => {
  return axios.get<InstructorSalaryResponseDto>(BASE, {
    params: { instructorId, month },
  })
}

export const createSalaryItem = (dto: CreateSalaryItemDto) => {
  return axios.post<SalaryItemDto>(`${BASE}/items`, dto)
}

export const updateSalaryItem = (id: string, dto: UpdateSalaryItemDto) => {
  return axios.put<SalaryItemDto>(`${BASE}/items/${id}`, dto)
}

export const deleteSalaryItem = (id: string) => {
  return axios.delete<void>(`${BASE}/items/${id}`)
}

export const getInstructorSalaryOverview = (month: string) => {
  return axios.get<InstructorSalaryOverviewItemDto[]>(`${BASE}/overview`, {
    params: { month },
  })
}
